// extracted by mini-css-extract-plugin
export default {"checklistDesktop":"checkdesktop_checklistDesktop__7+560","checkDesktop":"checkdesktop_checkDesktop__zz7Sk"};